import Alpine from "alpinejs";
import Splide from '@splidejs/splide';
import { Grid } from '@splidejs/splide-extension-grid';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

Alpine.data("imageSlider", () => ({
    splideInstances: {}, // Store instances by slider ID

    // Splide slide config
    type: 'loop',
    height: '44rem',
    perPage: 2,
    perMove: 1,
    gap: '16px',
    rewind: false,
    cover: true,
    speed: 800,

    // Initialize the slider and attach images
    init(sliderId, images, configuration) {
        if (sliderId && images) {

            const initialConfig = {
                configuration: configuration
            }
            // Initialize Splide slider
            if (sliderId) {
                this.reinitSlider(sliderId, images, false, initialConfig);
            }
        }

        // Attach a message listener to reinitialize sliders dynamically
        window.addEventListener('message', (event) => {
            if (event.data.type === 'change-imageSliderSettings') {
                let json = JSON.parse(event.data.data);

                const incomingSliderId = json.id;
                const images = json.images;

                // Reinitialize the specific slider
                if (incomingSliderId) {
                    this.reinitSlider(incomingSliderId.replace("slider", ""), images, true, json);
                }
            }
        });
    },

    reinitSlider(sliderId, images, isUpdateCall, json) {
        const sliderSelector = '#slider' + sliderId;

        if (this.splideInstances[sliderId]) {
            this.splideInstances[sliderId].splide.destroy();
        }

        // Set images in the splideInstances object
        this.splideInstances[sliderId] = {
            images: images, // Store images inside the instance
        };

        this.appendImages(sliderSelector, images);
        this.appendImages('#thumbnail-slider', images);

        const type = json && json.configuration && json.configuration.type ? json.configuration.type : this.type;
        const progressIndicator = json && json.configuration && json.configuration.progressIndicator ? json.configuration.progressIndicator : false;
        const gridEnabled = json && json.configuration && json.configuration.gridEnabled ? json.configuration.gridEnabled : false;
        const autoScrollEnabled = json && json.configuration && json.configuration.autoScroll ? json.configuration.autoScroll : false;
        const dimensions = json && json.configuration && json.configuration.dimensions ? json.configuration.dimensions : [];
        // Create and store a new Splide instance
        this.splideInstances[sliderId].splide = new Splide(sliderSelector, {
            lazyLoad: 'nearby',
            //type: type,
            height: json && json.configuration && json.configuration.sliderHeight && json.configuration.sliderHeight.desktop ? json.configuration.sliderHeight.desktop + 'px' : this.height,
            ...(type !== 'fade' ?
                { perPage: json && json.configuration && json.configuration.slidesPerPage && json.configuration.slidesPerPage.desktop ? json.configuration.slidesPerPage.desktop : this.perPage } :
                {}),
            perMove:  json && json.configuration && json.configuration.slidesPerMove && json.configuration.slidesPerMove.desktop ? json.configuration.slidesPerMove.desktop : this.perMove,
            gap: json && json.configuration && json.configuration.gap && json.configuration.gap.desktop ? json.configuration.gap.desktop + 'px' : this.gap,
            rewind: this.rewind,
            cover: this.cover,
            speed: json && json.configuration && json.configuration.speed ? json.configuration.speed : this.speed,
            direction: json && json.configuration && json.configuration.directions ? json.configuration.directions : 'ltr',
            autoplay: json && json.configuration && json.configuration.autoplay ? json.configuration.autoplay : false,
            pauseOnHover: json && json.configuration && json.configuration.pauseOnHover ? json.configuration.pauseOnHover : false,
            arrows: json && json.configuration ? json.configuration.arrows : true,
            pagination: json && json.configuration ? json.configuration.pagination : true,

            wheel: json && json.configuration ? json.configuration.wheel : false,
            waitForTransition: json && json.configuration ? json.configuration.wheel : false,

            type   : 'loop',
            drag   : 'free',

            grid : {
                // You can define rows/cols instead of dimensions.
                dimensions: dimensions,
                gap: {
                    row: json && json.configuration && json.configuration.gap && json.configuration.gap.desktop ? json.configuration.gap.desktop + 'px' : this.gap,
                    col: json && json.configuration && json.configuration.gap && json.configuration.gap.desktop ? json.configuration.gap.desktop + 'px' : this.gap,
                },
            },

            breakpoints: {
                1024: {
                    height: json && json.configuration && json.configuration.sliderHeight && json.configuration.sliderHeight.tablet ? json.configuration.sliderHeight.tablet + 'px' : this.height,
                    perPage: json && json.configuration && json.configuration.slidesPerPage && json.configuration.slidesPerPage.tablet ? json.configuration.slidesPerPage.tablet : this.perPage,
                    perMove:  json && json.configuration && json.configuration.slidesPerMove && json.configuration.slidesPerMove.tablet ? json.configuration.slidesPerMove.tablet : this.perMove,
                    gap: json && json.configuration && json.configuration.gap && json.configuration.gap.tablet ? json.configuration.gap.tablet + 'px' : this.gap,
                },
                767: {
                    height: json && json.configuration && json.configuration.sliderHeight && json.configuration.sliderHeight.mobile ? json.configuration.sliderHeight.mobile + 'px' : this.height,
                    perPage: json && json.configuration && json.configuration.slidesPerPage && json.configuration.slidesPerPage.mobile ? json.configuration.slidesPerPage.mobile : this.perPage,
                    perMove:  json && json.configuration && json.configuration.slidesPerMove && json.configuration.slidesPerMove.mobile ? json.configuration.slidesPerMove.mobile : this.perMove,
                    gap: json && json.configuration && json.configuration.gap && json.configuration.gap.mobile ? json.configuration.gap.mobile + 'px' : this.gap,
                },
            },

            autoScroll: {
                speed: json && json.configuration && json.configuration.autoScrollSpeed ? json.configuration.autoScrollSpeed : 1,
            },
        });

        var splideInstance = this.splideInstances[sliderId].splide;
        var bar = document.querySelector('.my-slider-progress').querySelector('.my-slider-progress-bar');

        if (progressIndicator) {
            document.querySelector('.my-slider-progress').style.display = 'block';
            if (bar) {
                // Function to update the progress bar
                function updateProgressBar() {
                    var end = splideInstance.Components.Controller.getEnd() + 1;
                    var rate = Math.min((splideInstance.index + 1) / end, 1); // Ensure the rate is between 0 and 1
                    bar.style.width = (100 * rate) + '%'; // Update width as percentage
                }

                // Update the progress bar when the slider is mounted or moved
                splideInstance.on('mounted move active', updateProgressBar);
            }
        }else {
            document.querySelector('.my-slider-progress').style.display = 'none';
        }

        // Prepare extensions dynamically based on the flags
        const extensions = {};
        if (autoScrollEnabled) extensions.AutoScroll = AutoScroll;
        if (gridEnabled) extensions.Grid = Grid;

        const thumbnailSlider = new Splide('#thumbnail-slider', {
            lazyLoad: 'nearby',
            rewind          : true,
            fixedWidth      : json && json.configuration && json.configuration.thumbnailsConfiguration && json.configuration.thumbnailsConfiguration.fixedWidth && json.configuration.thumbnailsConfiguration.fixedWidth.desktop ? json.configuration.thumbnailsConfiguration.fixedWidth.desktop + 'px' : 200,
            fixedHeight     : json && json.configuration && json.configuration.thumbnailsConfiguration && json.configuration.thumbnailsConfiguration.fixedHeight && json.configuration.thumbnailsConfiguration.fixedHeight.desktop ? json.configuration.thumbnailsConfiguration.fixedHeight.desktop + 'px' : 80,
            isNavigation    : true,
            gap             : 5,
            focus           : 'center',
            pagination      : false,
            cover           : true,
            dragMinThreshold: {
                mouse: 4,
                touch: 10,
            },

            breakpoints: {
                1024: {
                    fixedWidth  : json && json.configuration && json.configuration.thumbnailsConfiguration && json.configuration.thumbnailsConfiguration.fixedWidth && json.configuration.thumbnailsConfiguration.fixedWidth.tablet ? json.configuration.thumbnailsConfiguration.fixedWidth.tablet + 'px' : 66,
                    fixedHeight : json && json.configuration && json.configuration.thumbnailsConfiguration && json.configuration.thumbnailsConfiguration.fixedHeight && json.configuration.thumbnailsConfiguration.fixedHeight.tablet ? json.configuration.thumbnailsConfiguration.fixedHeight.tablet + 'px' : 38,
                },
                767: {
                    fixedWidth  : json && json.configuration && json.configuration.thumbnailsConfiguration && json.configuration.thumbnailsConfiguration.fixedWidth && json.configuration.thumbnailsConfiguration.fixedWidth.mobile ? json.configuration.thumbnailsConfiguration.fixedWidth.mobile + 'px' : 66,
                    fixedHeight : json && json.configuration && json.configuration.thumbnailsConfiguration && json.configuration.thumbnailsConfiguration.fixedHeight && json.configuration.thumbnailsConfiguration.fixedHeight.mobile ? json.configuration.thumbnailsConfiguration.fixedHeight.mobile + 'px' :38,
                },
            }
        });

        const thumbnailsEnabled = json && json.configuration && json.configuration.thumbnails ? json.configuration.thumbnails : false;

        if (thumbnailsEnabled) {
            splideInstance.sync(thumbnailSlider);
        }
        // Mount Splide with the selected extensions
        splideInstance.mount(extensions);

        const thumbnailSliderElement = document.getElementById('thumbnail-slider');
        if (thumbnailsEnabled) {
            thumbnailSlider.mount();

            // Dispatch a custom event to notify Alpine.js
            thumbnailSliderElement.dispatchEvent(new CustomEvent('update-thumbnails', {
                detail: { enabled: true },
            }));
        } else {
            // Dispatch a custom event to notify Alpine.js
            thumbnailSliderElement.dispatchEvent(new CustomEvent('update-thumbnails', {
                detail: { enabled: false },
            }));
        }

/*        // Detect when the last slide is reached
        splideInstance.on('moved', function (newIndex) {
            if (newIndex === splideInstance.length - 1) {
                document.getElementById('63d5c4e5-38a9-40ba-9d00-a43661128a07').scrollIntoView({ behavior: 'smooth' });
            }
        });*/

        if (json) {
            const arrowsElements = splideInstance.root.querySelectorAll('.splide__arrow'); // Use querySelectorAll to select all arrows
            const dotsElements = document.querySelector(sliderSelector).querySelectorAll('.splide__pagination__page');
            const progressBar = document.querySelector('#progress' + sliderId)
            arrowsElements.forEach(_element => {
                // Set the background color of the circle (arrow's container)
                _element.style.background = json.configuration.arrowsStyle.circleColor;

                // Set the fill color of the SVG (the arrow itself)
                const svg = _element.querySelector('svg');
                if (svg) {
                    svg.style.fill = json.configuration.arrowsStyle.arrowColor;
                }
            });

            dotsElements.forEach(_element => {
                // Set the background color of the circle (arrow's container)
                _element.style.background = json.configuration.paginationStyle.color;
            });

            //document.querySelector(sliderSelector).querySelector('.splide__pagination__page.is-active').style.background = json.configuration.paginationStyle.activeColor;

            progressBar.style.background = json.configuration.progressIndicatorStyle.color;
            progressBar.style.height = json.configuration.progressIndicatorStyle.height + 'px';
            progressBar.querySelector('.my-slider-progress-bar').style.background = json.configuration.progressIndicatorStyle.activeColor;
            progressBar.querySelector('.my-slider-progress-bar').style.height = json.configuration.progressIndicatorStyle.height + 'px';
        }

    },

    appendImagesById(sliderSelector, images) {
        const sliderContainer = document.querySelector(sliderSelector);
        if (!sliderContainer) {
            console.error(`Slider container not found for selector: ${sliderSelector}`);
            return;
        }

        const wrappers = sliderContainer.getElementsByClassName('splide__list');
        Array.from(wrappers).forEach((wrapper) => {
            wrapper.innerHTML = ''; // Clear previous content
            images.forEach((imgUrl) => {
                const slideElement = document.createElement('li');
                slideElement.classList.add('splide__slide');

                const imgElement = document.createElement('img');
                imgElement.src = imgUrl.src;
                imgElement.alt = imgUrl.alt || 'Image';
                slideElement.appendChild(imgElement);

                wrapper.appendChild(slideElement);
            });
        });
    },

    appendImages(sliderSelector, images) {
        // Select the slider container
        const sliderContainer = document.querySelector(sliderSelector);
        if (!sliderContainer) {
            console.error(`Slider container not found for selector: ${sliderSelector}`);
            return;
        }

        // Get all the wrapper elements
        const wrappers = sliderContainer.getElementsByClassName('splide__list');
        const pagination = sliderContainer.getElementsByClassName('splide__pagination')[0];

        // Clear the pagination if it exists
        if (pagination) {
            pagination.innerHTML = '';
        }

        // Loop through all wrappers and append images
        Array.from(wrappers).forEach((wrapper) => {
            // Clear previous content inside the wrapper
            wrapper.innerHTML = '';

            // Add images dynamically to the wrapper
            images.forEach((imgUrl) => {
                const slideElement = document.createElement('div');
                slideElement.classList.add('splide__slide'); // Add slide class for Splide

                // Create the image element
                const imgElement = document.createElement('img');
                imgElement.src = imgUrl.src; // Set the image source
                imgElement.alt = imgUrl.alt || 'Image'; // Use provided alt or default
                imgElement.classList.add('w-full'); // Tailwind utility class to make image fill the slide

                // Append the image to the slide element
                slideElement.appendChild(imgElement);

                // Append the slide element to the wrapper
                wrapper.appendChild(slideElement);
            });
        });
    }
}));
